import { Download, FileInput, Save } from 'lucide-react';
import { useRef, useState } from 'react';
import { usePhoto } from '../context/PhotoContext';
import { useLanguage } from '../i18n';

export function PresetRail(): JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null);
  const [name, setName] = useState('');
  const { presets, applyPreset, saveCurrentPreset, exportPresets, importPresets } = usePhoto();
  const { t } = useLanguage();

  return (
    <aside className="border-b border-[color:var(--line)] bg-[color:var(--surface)] lg:h-[calc(100vh-3.5rem)] lg:w-64 lg:overflow-y-auto lg:border-b-0 lg:border-r">
      <div className="flex gap-2 overflow-x-auto p-3 lg:block lg:space-y-2">
        {presets.map((preset) => (
          (() => {
            const displayName = preset.builtIn ? t(`preset.${preset.id}.name`) : preset.name;
            const displayDescription = preset.builtIn ? t(`preset.${preset.id}.description`) : preset.description;
            return (
          <button
            key={preset.id}
            onClick={() => applyPreset({ ...preset, name: displayName })}
            className="min-w-44 rounded-lg border border-[color:var(--line)] bg-[color:var(--panel)] p-3 text-left transition hover:border-[color:var(--accent)] lg:w-full"
          >
            <span className="block text-sm font-semibold">{displayName}</span>
            <span className="mt-1 block text-xs text-[color:var(--muted)]">{displayDescription}</span>
          </button>
            );
          })()
        ))}
      </div>

      <div className="border-t border-[color:var(--line)] p-3">
        <label className="control-label mb-2 block">{t('preset.local')}</label>
        <div className="flex gap-2">
          <input className="input-field min-w-0 flex-1" placeholder={t('preset.placeholder')} value={name} onChange={(event) => setName(event.target.value)} />
          <button
            className="icon-button"
            aria-label={t('preset.save')}
            onClick={() => {
              saveCurrentPreset(name);
              setName('');
            }}
          >
            <Save size={16} />
          </button>
        </div>
        <div className="mt-2 grid grid-cols-2 gap-2">
          <button className="icon-button gap-2" onClick={exportPresets}>
            <Download size={15} />
            {t('preset.export')}
          </button>
          <button className="icon-button gap-2" onClick={() => inputRef.current?.click()}>
            <FileInput size={15} />
            {t('preset.import')}
          </button>
        </div>
        <input
          ref={inputRef}
          type="file"
          className="sr-only"
          accept="application/json"
          onChange={(event) => {
            const file = event.target.files?.[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = () => importPresets(String(reader.result ?? ''));
            reader.readAsText(file);
            event.currentTarget.value = '';
          }}
        />
      </div>
    </aside>
  );
}
